import {
    createStoreFilter,
    StoreNameOnlyExtractor,
} from 'src/modules/store/extractors';
import { IStore } from 'src/interfaces/store';

const extractor = new StoreNameOnlyExtractor();

/**
 * Get all store names by make
 * @param stores - The stores to get the store names from
 * @param makeId - The make id to get the store names from
 * @returns An array of store names
 */

export const getStoreNamesByMake = (
    stores: IStore[],
    makeId: string
): string[] => createStoreFilter(extractor)(stores, makeId);
